import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LocalSaveService } from 'src/app/services/local-save-service.service';

@Component({
  selector: 'app-mapa-cita-filters',
  templateUrl: './mapa-cita-filters.component.html',
  styleUrls: ['../mapa-cita.component.scss']
})
export class MapaCitaFiltersComponent {

  @Input() grupoVal: FormGroup;
  @Input() modoMapa: 'CITAS' | 'ALARMAS';
  @Input() total_alarmas: number;
  @Input() prioridades: any[];
  @Input() provincias: any[];
  @Input() contratasagente: any[];
  @Input() agentes: any[];
  @Input() agentesFiltrados: any[];
  @Input() tiempos: any[];
  @Input() searchTecnico: string;

  // Summary data
  @Input() citas: any[];
  @Input() citas_asignadas: number;
  @Input() citas_encamino: number;
  @Input() citas_encurso: number;
  @Input() citas_completado: number;
  @Input() citas_sinasignacion: number;
  @Input() citas_sincoordenadas: number;
  @Input() total_alarmas1: number;
  @Input() total_alarmas2: number;
  @Input() total_alarmas3: number;
  @Input() total_alarmas4: number;
  @Input() totales_altec: any;
  @Input() isOpen: boolean;

  @Output() modoMapaChange = new EventEmitter<'CITAS' | 'ALARMAS'>();
  @Output() filtroGeneralRequested = new EventEmitter<void>();
  @Output() limpiarFiltrosRequested = new EventEmitter<void>();
  @Output() provinciaSeleccionada = new EventEmitter<any>();
  @Output() contrataSeleccionada = new EventEmitter<any>();
  @Output() tecnicoDropdownToggled = new EventEmitter<boolean>();
  @Output() tecnicosFiltrados = new EventEmitter<void>();
  @Output() searchTecnicoChange = new EventEmitter<string>();
  @Output() toggleBoxRequested = new EventEmitter<void>();
  @Output() isOpenChange = new EventEmitter<boolean>();

  constructor(public localSave: LocalSaveService) { }

  onModoMapaChange(newModo: 'CITAS' | 'ALARMAS') {
    this.modoMapaChange.emit(newModo);
  }

  filtrogeneral() {
    this.filtroGeneralRequested.emit();
  }

  limpiarFiltros() {
    this.limpiarFiltrosRequested.emit();
  }

  onProvinciaSeleccionada(event: any) {
    this.provinciaSeleccionada.emit(event);
  }

  onContrataSeleccionada(event: any) {
    this.contrataSeleccionada.emit(event);
  }

  onTecnicoDropdownToggle(opened: boolean) {
    this.tecnicoDropdownToggled.emit(opened);
  }

  filtrarTecnicos() {
    this.tecnicosFiltrados.emit();
  }

  onSearchTecnicoChange(value: string) {
    this.searchTecnicoChange.emit(value);
  }

  toggleBox() {
    this.toggleBoxRequested.emit();
  }
}
